<template>
  <div class="progresaBar">
    <div class="label">
      <div v-if="showPartyInfo" class="partyInfo">
        <div class="logoWrapper">
          <img :src="`images/parties/${party.logo}`" />
        </div>
        {{ party.name }}
      </div>

      <div v-if="label" class="text-label">{{ label }}</div>
    </div>

    <div class="totals">
      <slot>{{ procentage }}%</slot>
    </div>

    <div class="bar" :style="`width: ${procentage}%`" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    showPartyInfo: Boolean,
    partyId: Number,
    label: String,
    value: Number,
    total: Number,
  },

  computed: {
    ...mapGetters(["getPartyById"]),

    party() {
      return this.getPartyById(this.partyId);
    },

    procentage() {
      const p = (this.value / this.total) * 100;
      return p ? p : 0;
    },
  },
};
</script>

<style scoped lang="scss">
.progresaBar {
  height: 48px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  overflow: hidden;
  justify-content: space-between;
  background: $lightblue;
  color: white;
  position: relative;
  @include type-default();
  @include type-strong();

  & + .progresaBar {
    margin-top: 10px;
  }
}

.partyInfo {
  display: flex;
  align-items: center;
}

.label,
.totals {
  position: relative;
  z-index: 1;
}

.logoWrapper {
  width: 42px;
  height: 42px;
  border-radius: 100px;
  overflow: hidden;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  margin-left: 4px;
}

img {
  width: 70%;
  height: 70%;
  object-fit: contain;
  object-position: center;
}

.totals {
  margin-right: 20px;
}

.text-label {
  margin-left: 20px;
}

.bar {
  position: absolute;
  height: 100%;
  width: 0%;
  background: $blue;
  border-radius: 100px;
}
</style>
